export default "__VITE_ASSET__CIwgGLjv__"